module.exports = function() {
  return new Worker(__webpack_public_path__ + "a8730430c9687e43c3db.worker.js");
};